




















export default {
    name: "Pagination",
    props: {
        defaultPage: Number,
        totalPages: Number,
    },
    data() {
        return {
            currentPage: 1,
        };
    },
    created() {
        if (this.defaultPage) {
            this.currentPage = this.defaultPage;
        }
    },
    methods: {
        goToPage(p: number): void {
            this.currentPage = p;
            this.$emit("page-changed", p);
        },
    },
    computed: {
        range(): Array<number> {
            let minVal = Math.max(this.currentPage - 3, 1);
            let maxVal = Math.min(this.currentPage + 3, this.totalPages) + 1;
            return _.range(minVal, maxVal);
        },
    },
};
